/**
 * Atteniv brand tokens.
 *
 * Single source of truth for brand colours used by the portal's custom
 * components. Values are taken from the marketing site (`../atteniv-marketing`)
 * so the portal stays visually consistent with atteniv.com:
 *
 *   - BRAND_PRIMARY  `#16423C`  the logo fill and favicon background
 *   - BRAND_ACCENT   `#FF1C46`  CSS `--primary`, hsl(349 100% 55.5%)
 *
 * The Backstage theme's own primaryColor is set separately in app-config.yaml;
 * keep the two in sync when changing these.
 */
export const BRAND_PRIMARY = '#16423C';
export const BRAND_ACCENT = '#FF1C46';

/** Neutral slate ramp used by the dashboard cards. */
export const NEUTRAL = {
  heading: '#1e293b',
  body: '#475569',
  muted: '#64748b',
  faint: '#94a3b8',
  border: '#e2e8f0',
  borderSoft: '#f1f5f9',
  surface: '#f8fafc',
} as const;

export const STATUS = {
  successFg: '#059669',
  successBg: '#ecfdf5',
  dangerFg: '#dc2626',
  dangerBg: '#fef2f2',
} as const;
